export const LOCAL_STORAGE_TOKEN_KEY = 'AUTH_TOKEN';

export const SUPPORTED_TOKENS = {
    BTC: ['BTC'],
    SOL: ['SOL', 'USDT', 'USDC'],
    ETH: ['ETH', 'USDT', 'USDC', 'DAI'],
    BSC: ['BNB', 'USDT', 'USDC', 'BUSD'],
    MATIC: ['MATIC', 'USDT', 'USDC'],
    FTM: ['FTM', 'USDT', 'DAI'],
    AVAX: ['AVAX', 'USDT', 'USDC'],
};

export const ALL_SUPPORTED_TOKENS = [
    ...new Set(Object.values(SUPPORTED_TOKENS).reduce((acc, val) => [...acc, ...val], [])),
];

export const TRANSACTION_EXPLORER_LINK = {
    BTC: 'https://www.blockchain.com/btc/tx/',
    SOL: 'https://solscan.io/tx/',
    ETH: 'https://etherscan.io/tx/',
    BSC: 'https://bscscan.com/tx/',
    MATIC: 'https://polygonscan.com/tx/',
    FTM: 'https://ftmscan.com/tx/',
    AVAX: 'https://snowtrace.io/tx/',
};

export const NETWORK_NAME_LABELS = {
    BTC: 'Bitcoin',
    SOL: 'Solana',
    ETH: 'Ethereum',
    BSC: 'Binance Smart Chain',
    MATIC: 'Polygon',
    FTM: 'Fantom',
    AVAX: 'Avalanche',
};

export const TRANSACTION_STATES = {
    COMPLETED: 'completed',
    FAILED: 'failed',
    PENDING: 'pending',
};

export const EVM_CHAIN_IDS = {
    ETH: 1,
    BSC: 56,
    MATIC: 137,
    AVAX: 43114,
    FTM: 250,
};

export const COLLECTED_CUSTOMER_DATE_VALUES = {
    EMAIL: 'Email',
    FIRST_NAME: 'First Name',
    LAST_NAME: 'Last Name',
    ADDRESS: 'Address',
    NOTES: 'Notes',
};

export const PAYMENT_STATES_LABELS = {
    initialized: 'Initialized',
    canceled: 'Canceled',
    pending: 'Pending',
    completed: 'Completed',
    failed: 'Failed',
    'completed-with-failed-call-to-webhook': 'Completed with failed call to webhook',
};

export const LOGO_URL = 'https://bucket1-payonix.s3.amazonaws.com/P%20icon-01.png';
